import { packagingTypeIcons, packagingTypes } from '@/common/constants'

import { packagingTypeLabels } from '../constants'

export const getPackagingTypeIcon = (type, isEnabled, t, theme) => {
  const iconProps = {
    size: 20,
    color: isEnabled ? theme.colors.text.default : theme.colors.text.subtle,
    alt: t(packagingTypeLabels[type]),
  }

  const Icon = packagingTypeIcons[type]
  if (!Icon) return null

  const testIds = {
    [packagingTypes.box]: 'box-icon',
    [packagingTypes.envelope]: 'envelope-icon',
  }

  return <Icon {...iconProps} data-testid={testIds[type]} />
}
